// extracted by mini-css-extract-plugin
export default {"emptyStatesContainer":"pRy83j"};